import { Color, DefaultValue, Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const User = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  margin: ${Spacing.S12} 0;
  padding: ${Spacing.S12} ${Spacing.S16};
  border-radius: ${DefaultValue.BorderRadius};
  background-color: ${Color.Grey100};
  text-align: left;
`
